<script setup lang="ts">

const BASE_HEIGHT_PERCENT = 50;

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  max: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    required: true,
  },
  gap: {
    type: Number,
    required: false,
    default: 2,
  },
  bars: {
    type: Number,
    required: false,
    default: 5,
  },
});

const calculateHeight = (index: number): string => {
  const offset = Math.ceil((index / props.bars) * 50);
  const level = BASE_HEIGHT_PERCENT + offset;
  return `h-[${level}%]`;
};

const threshold = (props.value / props.max - props.min) * props.bars;

const calculateLevel = (index: number) =>
  index > threshold
    ? 'bg-muted'
    : 'bg-foreground';

const spaceStyle = ['space-x-0', 'space-x-1', 'space-x-2'][props.gap];

</script>

<template>
  <div class="flex flex-col items-center h-full w-full justify-center">
    <div
      class="flex flex-row h-full w-full items-end"
      :class="[spaceStyle]"
    >
      <div
        v-for="index in bars"
        :key="`bar${index}`"
        class="flex flex-1 border-2 border-strong"
        :class="[calculateHeight(index), calculateLevel(index)]"
      />
    </div>
    <div class="text-foreground text-m pt-2 opacity-75">
      {{ props.label }}
    </div>
  </div>
</template>
